import { render, staticRenderFns } from "./UpdateAd.vue?vue&type=template&id=1c82d866"
import script from "./UpdateAd.vue?vue&type=script&lang=ts"
export * from "./UpdateAd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports